import { render, staticRenderFns } from "./change-wiki.vue?vue&type=template&id=75687217&"
import script from "./change-wiki.vue?vue&type=script&lang=ts&"
export * from "./change-wiki.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports